<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-tab-bar</h2>
            <p class="demo-description">POS navigation — a bottom tab bar for switching between point-of-sale sections.</p>

            <!-- Primary POS tabs -->
            <div class="demo-section">
    <h3>Main POS Navigation</h3>

    <div class="tab-content-area">
        <ion-icon name="reader-outline" class="tab-content-icon"></ion-icon>
        <p class="tab-content-text">{{ tabContent[selectedTab] }}</p>
    </div>

    <upp-tab-bar [selected]="selectedTab" (Selected)="onTabSelected($event)">
        <upp-tab-button tabname="catalog" tablabel="Catalog" tabicon="grid-outline"></upp-tab-button>
        <upp-tab-button tabname="cart" tablabel="Cart" tabicon="cart-outline"></upp-tab-button>
        <upp-tab-button tabname="tickets" tablabel="Tickets" tabicon="receipt-outline"></upp-tab-button>
        <upp-tab-button tabname="settings" tablabel="Settings" tabicon="settings-outline"></upp-tab-button>
    </upp-tab-bar>

    <p class="demo-label">Selected: <strong>{{ selectedTab }}</strong></p>
</div>

<!-- Secondary tabs (different icons) -->
<div class="demo-section">
    <h3>Restaurant Mode (3 tabs)</h3>

    <div class="tab-content-area">
        <ion-icon name="reader-outline" class="tab-content-icon"></ion-icon>
        <p class="tab-content-text">{{ tabContent2[selectedTab2] }}</p>
    </div>

    <upp-tab-bar [selected]="selectedTab2" (Selected)="onTab2Selected($event)">
        <upp-tab-button tabname="tables" tablabel="Tables" tabicon="apps-outline"></upp-tab-button>
        <upp-tab-button tabname="orders" tablabel="Orders" tabicon="list-outline"></upp-tab-button>
        <upp-tab-button tabname="stats" tablabel="Stats" tabicon="bar-chart-outline"></upp-tab-button>
    </upp-tab-bar>

    <p class="demo-label">Selected: <strong>{{ selectedTab2 }}</strong></p>
</div>
        </div>
    </upp-scrollable>
</div>
